// extracted by mini-css-extract-plugin
export var contactPageTitle = "index-module--contactPageTitle--3PB_C";
export var readText = "index-module--readText--2BNr1";
export var container = "index-module--container--bBM5K";
export var form = "index-module--form--1sd91";